import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-assurezvous',
  templateUrl: './assurezvous.component.html',
  styleUrls: ['./assurezvous.component.css']
})
export class AssurezvousComponent implements OnInit {

  constructor(
    private globalSvc: GlobalService
  ) { }

  ngOnInit(): void {
    this.globalSvc.fixDisplay();
  }

}
